import sortByArrayUtil from 'packages/src/modules/array/sort-by'

function getKeysBySortedNumberValues (obj, order = 'desc') {
  const sortedValues = sortByArrayUtil(
    Object
      .keys(obj || {})
      .map(Number), key => {
      const count = obj[key]
      return order === 'desc'
        ? -1 * count
        : count
    }
  )
  // Filter low values
  const topValue = sortedValues[0]
  if (!topValue) {
    return []
  }
  return sortedValues.filter(value => {
    return value / topValue > 0.25
  })
}

export {
  getKeysBySortedNumberValues
}
